import { VayuBlocksCssJustify,boxShadow,VayuBlocksCssborderFrame, dimensions, borderStyle, borderRadiusStyle} from "@vayu-blocks/global";

export const frame = (attributes, view) => ({
    ...VayuBlocksCssborderFrame(attributes.frameData, view),
});

export const getOverlayStyle = (attributes, view) => {

    const vayu_block_overlay_style = {
        overflow:'hidden',
        position: 'relative',
        zIndex: 12,
        '--background-Overlay': attributes.pooverlaycolor,
        '--backgroun-hover-Overlay': attributes.pooverlayhvrcolor || attributes.pooverlaycolor,
        '--wrapper-overlay-po-opacity': attributes.pooverlayopacity || 0.5,
    };

    return vayu_block_overlay_style;
};

export const getCaptionStyle = (attributes, view) => {
    let style = {
        color: attributes.captioncolor,
    };

    switch (view) {
        case 'Tablet':
            style.fontSize = attributes.captionsizeTablet;
            style.fontWeight = attributes.captionfontweightTablet;
            break;

        case 'Mobile':
            style.fontSize = attributes.captionsizeMobile;
            style.fontWeight = attributes.captionfontweightMobile;
            break;

        case 'Desktop':
            style.fontSize = attributes.captionsize;
            style.fontWeight = attributes.captionfontweight;
            break;

        default:
            break;
    }

    return style;
};

export const getImagePositionStyle = (attributes, view) => {

    return {
        display: 'flex',
        ...VayuBlocksCssJustify(attributes.imagealignment, view),
    };
};

export const getImageWrapperStyle = (attributes, view) => {
    const style = {
        ...(attributes.imageboxShadowColor && {
            boxShadow: attributes.imageboxShadow
                ? `${attributes.imageboxShadowHorizontal}px ${attributes.imageboxShadowVertical}px ${attributes.imageboxShadowBlur}px ${attributes.imageboxShadowSpread}px rgba(${parseInt(attributes.imageboxShadowColor.slice(1, 3), 16)}, ${parseInt(attributes.imageboxShadowColor.slice(3, 5), 16)}, ${parseInt(attributes.imageboxShadowColor.slice(5, 7), 16)}, ${attributes.imageboxShadowColorOpacity / 100})`
                : 'none',
        }),
    };

    const width = attributes.imagewidth || 'auto';
    const height = attributes.imageheight || 'auto';

    if (view === 'Desktop') {
        style.width = width;
        style.height = height;
    } else if (view === 'Tablet') {
        style.width = attributes.imagewidthtablet || 'auto';
        style.height = attributes.imageheighttablet || 'auto';
    } else if (view === 'Mobile') {
        style.width = attributes.imagewidthmobile || 'auto';
        style.height = attributes.imageheightmobile || 'auto';
    }

    return style;
};

export const getImageStyle = (attributes, view) => {

    return {
        background:attributes.videoboxcolor,

        ...(attributes.duotone?.length > 1 && {
            filter: `url(#duotone-filter-${attributes.uniqueId})`,
        }),
    };
};

export const getImageStylecont = (attributes, view) => {
	const baseStyle = {
		...boxShadow(attributes.imageboxShadow, view),
		...borderRadiusStyle(attributes.frameData.radius, view),
		background: attributes.videoboxcolor,
	};

	let screenFitStyle = {};

	if (attributes.screenfit === 'auto') {
		screenFitStyle.aspectRatio = attributes.imageaspectratio?.[view] || 16 / 9;

		if (view === 'Tablet') {
			screenFitStyle.width = '600px';
		} else if (view === 'Mobile') {
			screenFitStyle.width = '280px';
		} else {
			screenFitStyle.width = '650px';
		}
	}

	if (attributes.screenfit === 'screenfit') {
		screenFitStyle = {
			width: '100vw',
			height: '100vh',
		};
	}

	if (attributes.screenfit === 'custom') {
		screenFitStyle = {
			width: attributes.videowidth?.[view],
			height: attributes.videoheight?.[view],
		};
	}

	return {
		...baseStyle,
		...screenFitStyle,
	};
};

export const videoimagestyles = (attributes, view) => {
    const baseStyles = {
        ...boxShadow(attributes.imageboxShadow, view),
        ...borderRadiusStyle(attributes.frameData.radius, view),
        background: attributes.videoboxcolor,
    };

    let sizeStyles = {};

    if (attributes.screenfit === 'auto') {
        sizeStyles.aspectRatio = attributes.imageaspectratio?.[view] || 16 / 9;

        if (view === 'Tablet') {
            sizeStyles.width = '600px';
        }else if(view === 'Mobile'){
            sizeStyles.width = '280px';
        }else{
            sizeStyles.width = '650px';
        }
    } else if (attributes.screenfit === 'screenfit') {
            sizeStyles = {
                width: '100vw',
                height: '100vh',
            };
    } else if (attributes.screenfit === 'custom') {
        sizeStyles = {
            width: attributes.videowidth?.[view],
            height: attributes.videoheight?.[view],
        };
    }

    return {
        ...baseStyles,
        ...sizeStyles,
    };
};

export const iconStylesmain = (attributes, getView) => {
	let alignment = {};

    const getAlignment = (alignment) => {
        const [vertical, horizontal] = alignment.split(' ');
        return {
            alignItems:
                vertical === 'center' ? 'center' :
                vertical === 'top' ? 'self-start' :
                vertical === 'bottom' ? 'self-end' : 'center',
            justifyContent:
                horizontal === 'center' ? 'center' :
                horizontal === 'left' ? 'flex-start' :
                horizontal === 'right' ? 'flex-end' : 'center',
        };
    };

	if (getView === 'Desktop') {
		alignment = getAlignment(attributes.overlayalignment);
	} else if (getView === 'Tablet') {
		alignment = getAlignment(attributes.overlayalignmenttablet);
	} else if (getView === 'Mobile') {
		alignment = getAlignment(attributes.overlayalignmentmobile);
	}

	return {
		...alignment,
	};
};

export const cancel = (attributes, getView) => {
	return {
		normal: {
			padding: dimensions(attributes.cancelpadding, getView),
			...boxShadow(attributes.cancelDropShadow, getView),
			...borderStyle(attributes.cancelBorder, getView),
			...borderRadiusStyle(attributes.cancelRadius, getView),
            background:attributes.cancelbg,
            color:attributes.cancelcolor,
            size: attributes.cancelSize?.[getView],
		},
		hover: {
			...boxShadow(attributes.cancelDropShadowHover, getView, attributes.cancelDropShadow),
			...borderStyle(attributes.cancelBorderHover, getView, attributes.cancelBorder),
			...borderRadiusStyle(attributes.cancelRadiusHover, getView, attributes.cancelRadius),
            background:attributes.cancelbghover,
            color:attributes.cancelcolorhover,
		}
	};
};
